module.exports = __webpack_public_path__ + "1d69ab1773ce7511448ef0bf9c1730f3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/font/ppa-icon.ttf
// module id = 2256
// module chunks = 2